'use strict';

var shallowEqual = require('react/lib/shallowEqual');

/**
 * A helper to avoid creating immutable objects
 * if they don't differ from previous values.
 */
function firstIfShallowEqual(first, second) {
  if (!first || !second) {
    return second;
  }

  return shallowEqual(first, second) ?
    first :
    second;
}

module.exports = firstIfShallowEqual;


/** WEBPACK FOOTER **
 ** ./utils/firstIfShallowEqual.js
 **/